import React, { Component } from "react";

import { Link } from "gatsby";


import HomeBanner from "../components/homeBanner"

import MyTwinMyTreat from "../components/myTwinMyTreat"
import LeadingDoctors from "../components/leadingDoctors"
import PatientSuccessStories from "../components/patientSuccessStories"
import HorizontalAcc from "../components/horizontalAcc"
import Layout from "../components/layout"
import Twinresults from "../components/twinresults"
import StopManagingStartReversing from "../components/stop-managing-startreversing"
import { Helmet } from "react-helmet";

import HomeTwinTreatment from "../components/home-twin-treatment"
import FAQ from "../components/accordian";


import Swiper, { Navigation, Pagination, Autoplay  } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';
 import "./indexStyles.css"
 
Swiper.use([Navigation, Pagination, Autoplay]);

class Home extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false
    };
    this.openModal = this.openModal.bind(this)
  }
  
  openModal () {
    this.setState({isOpen: true})
  }
 
  componentDidMount(){
    window.scrollTo(0, 0)
    /****** BANNER SLIDER CODE *********/
var mySwiper = new Swiper('.banner-swiper', {
  speed: 2000,
  autoplay: true,
  loop: true,
  autoHeight: true
});
    /****** LEADING DOC SLIDER CODE *********/
var swiper = new Swiper('.leading-swiper', {
  autoplay: false,
  autoHeight: true,
  spaceBetween: 15,
  pagination: {
      el: '.swiper-pagination',
      clickable: true
  },
  // navigation: {
  //     nextEl: '.swiper-button-next',
  //     prevEl: '.swiper-button-prev',
  // }
});
/****** PATIENTS STORIES SLIDER CODE *********/

var swiper2
 = new Swiper('.patients-stories', {
  slidesPerView: 3,
  spaceBetween: 30,
  pagination: {
      el: '.swiper-pagination',
      clickable: true,
  },
  breakpoints: {
// when window width is >= 320px
      320: {
          slidesPerView: 1,
          spaceBetween: 30
      },
      // when window width is >= 480px
      576: {
          slidesPerView: 2,
          spaceBetween: 15
      },
      768: {
          slidesPerView: 2,
          spaceBetween: 30
      },
      // when window width is >= 640px
      992: {
          slidesPerView: 3,
          spaceBetween: 30,
      }
  }
});
}
 


  render() {
    
    return (
      <Layout>
        <Helmet>
          <title>
          Reverse diabetes & get your blood sugar back to normal sugar level | Twin Health
          </title>
          <meta
            name="description"
            content="Diabetes reversal is possible. Get your sugar level back to normal & reduce diabetes symptoms. Consultation from top endocrinologists & diabetologists. No medicines."
          />
          <meta name="keywords" content="diabetes reversal,normal sugar level,sugar level,reverse diabetes,diabetes symptoms,endocrinologist,medicines,metabolism" />
          </Helmet>
            <HomeBanner/>
            <HorizontalAcc/>
            <Twinresults/>
            <MyTwinMyTreat/>
            <PatientSuccessStories/>
            <LeadingDoctors/>
            <StopManagingStartReversing/>
             <section>
            <div className="faq col-md-12">
            <div className="faqmaindiv">
              <div className='faqsubdiv'>
                <h3>Frequently Asked Questions</h3>
                <div className="faqcontent">
                
                    <FAQ
                      title="Q: How many patients have successfully reversed their diabetes?"
                      content="Twin Health has helped more than 1000 patients successfully reverse their diabetes." />
                    <FAQ
                      title="Q: How long is the treatment for?"
                      content={
                        <div>
                          The treatment is for 1 year distributed into 4 phases as below: <br/>
                          <b>Quarter 1:</b> Reducing sugar levels, getting your HbA1c below 6.5<br/>
                          <b>Quarter 2:</b> Managing chronic conditions BP, cholesterol and obesity<br/>
                          <b>Quarter 3:</b> Improving organ health by reducing inflammation and oxidative stress<br/>
                          <b>Quarter 4:</b> Beta cells regeneration to complete permanent reversal
                        </div>
                      } />
                    <FAQ
                      title="Q: Are there any side-effects of this treatment?"
                      content="TWIN precision treatment follows a 100% safe and natural process to reverse your diabetes. All sensors are FDA approved and the program is offered by the leading diabetologists of India." />
                 
                </div>
              </div>
            </div>
          </div>
          </section>
            
           
      </Layout>
    )
  }

}

export default Home;











